import { DataParams, ParamsConfig } from "../types";

function getPartnerData(params: ParamsConfig) {
    let dataParams: DataParams | undefined = undefined;

    //TMobile Poland specific flow.
    //Instead of selecting a plan, we pass in an accessCode the user will have from the T-Mobile link
    //and pass this in as a parameter. The user will be made premium on backend, and we just go directly to the success screen if it works
    if(params.config === "dvk-tmobile-pl" && params.accessCode !== undefined)
    {
      dataParams = {
        "PARTNER": "TMPL",
        "ACCESSCODE": params.accessCode
      }
    }
    //Curiosity specific flow.
    //Same as above.
    else if(params.config === "dvk-curiosity" && params.userID !== undefined)
    {
      dataParams = {
        "PARTNER": "CURIOSITY",
        "USERID": params.userID
      }
    }
    //Magyar specific flow.
    //Token validation is done outside of this function due to the Mutation function
    //managing an "isLoading" variable that both registration and login need to keep track of to disable UI.
    else if(params.config === "dvk-magyar-telecom" && params.token !== undefined)
    {
      dataParams = {
        "PARTNER": "MAGYAR",
        "TOKEN": params.token
      }
    }

    return dataParams;
}

export default getPartnerData